import { semanticColors } from "@/designTokens";

// マッチ度の数字は、相性グラフと同じブランドブルーで強調する。
export const MATCH_SCORE_COLOR = semanticColors["action/primary"];
export const MATCH_LABEL_COLOR = semanticColors["text/secondary"];
export const AVATAR_BORDER_COLOR = semanticColors["border/strong"];
